import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

type OneRowSkeletonProps = {
  columnsMdUp?: 2 | 3; // Controls number of columns at md+
};

export const OneRowSkeleton: React.FC<OneRowSkeletonProps> = ({ columnsMdUp = 2 }) => {
  const mdColumnWidth = 12 / columnsMdUp; // 6 for 2 columns, 4 for 3 columns

  return (
    <Box width="100%" padding={2} sx={{ height: '100%' }}>
      <Grid container spacing={2} sx={{ height: '100%' }}>
        {[...Array(columnsMdUp)].map((_, index) => (
          <Grid key={index} sx={{
            width: {
              xs: '100%',                    // xs=12 → full width
              md: `${(mdColumnWidth / 12) * 100}%`, // md={mdColumnWidth} → percentage
            },
          }} >
            <Box
              display="flex"
              flexDirection="column"
              borderRadius={2}
              boxShadow={1}
              padding={2}
              height="100%"
              sx={{ height: '100%' }}
            >
              <Skeleton variant="rectangular" height={'60%'} />
              <Skeleton variant="text" width="60%" height={'20%'} sx={{ mt: 2 }} />
              <Skeleton variant="text" width="80%" height={'10%'} />
              <Skeleton variant="text" width="80%" height={'10%'} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
